import { createContext, useContext, useState, useCallback, useRef } from 'react';

const ConfirmContext = createContext(null);

export function ConfirmProvider({ children }) {
  const [state, setState] = useState({ open: false, message: '', title: '' });
  const resolveRef = useRef(null);

  const confirm = useCallback((message, title = 'Confirmation') => {
    return new Promise((resolve) => {
      resolveRef.current = resolve;
      setState({ open: true, message, title });
    });
  }, []);

  const handleConfirm = () => {
    setState({ open: false, message: '', title: '' });
    resolveRef.current?.(true);
  };

  const handleCancel = () => {
    setState({ open: false, message: '', title: '' });
    resolveRef.current?.(false);
  };

  return (
    <ConfirmContext.Provider value={{ confirm }}>
      {children}
      {state.open && (
        <div className="confirm-overlay" onClick={handleCancel}>
          <div className="confirm-modal" onClick={(e) => e.stopPropagation()}>
            <div className="confirm-icon">
              <i className="bi bi-exclamation-triangle" />
            </div>
            <h3 className="confirm-title">{state.title}</h3>
            <p className="confirm-message">{state.message}</p>
            <div className="confirm-actions">
              <button className="btn btn-secondary" onClick={handleCancel}>
                <i className="bi bi-x-lg" /> Annuler
              </button>
              <button className="btn btn-danger" onClick={handleConfirm}>
                <i className="bi bi-trash" /> Supprimer
              </button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
}

export function useConfirm() {
  const ctx = useContext(ConfirmContext);
  if (!ctx) throw new Error('useConfirm must be used within ConfirmProvider');
  return ctx.confirm;
}
